import styled from "styled-components";

const StyledArrow = styled.div`
  display: inline-block;
  border: solid
    ${(props) => (props.isDisabled ? "grey" : props.color || "black")};
  border-width: 0 ${(props) => props.size || 4}px
    ${(props) => props.size || 4}px 0;
  padding: ${(props) => props.padding || 4}px;
  pointer-events: ${(props) => (props.isDisabled ? "none" : "default")};
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  margin: 2px;
  transition: all 0.2s;
  ${(props) => {
    switch (props.direction) {
      case "left":
        return `
                    transform: rotate(135deg);
                    -webkit-transform: rotate(135deg);
                    `;
      case "right":
        return `
                    transform: rotate(-45deg);
                    -webkit-transform: rotate(-45deg);
                    `;
      case "down":
        return `
                    transform: rotate(45deg);
                    -webkit-transform: rotate(45deg);
                    `;

      case "up":
        return `
                    transform: rotate(-135deg);
                    -webkit-transform: rotate(-135deg);
                    `;
    }
  }}
`;

const ArrowLeft = styled(StyledArrow)`
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
`;

const ArrowRight = styled(StyledArrow)`
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
`;

export { StyledArrow, ArrowLeft, ArrowRight };
